import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScreeningFee, ScreeningFeeCreate, ScreeningApiUser } from 'models';

@Injectable({
	providedIn: 'root',
})
export class ScreeningFeeService {
	constructor(private http: HttpClient) {}

	get(): Observable<ScreeningFee[]> {
		return this.http.get<ScreeningFee[]>(`api/screeningfees/get`);
	}

	create(screeningFees: ScreeningFeeCreate[]): Observable<null> {
		return this.http.post<null>(`api/screeningfees/create`, screeningFees);
	}

	update(screeningFees: ScreeningFeeCreate[]): Observable<null> {
		return this.http.post<null>(`api/screeningfees/update`, screeningFees);
	}

	getByUserId(userId: string): Observable<ScreeningApiUser> {
		return this.http.get<ScreeningApiUser>(`api/screeningfees/get/${userId}`);
	}
}
